<template>
  <nav>
    <v-layout wrap>
        <v-toolbar dark app color="#232323">
            <v-toolbar-side-icon class="hidden-md-and-up" @click="toggleDrawer" />
                <v-toolbar-title class="headline text-uppercase">  
                    <a href="/"><img src="/img/masha-logo.png" class="img-fluid" /></a>
                </v-toolbar-title>

        <v-spacer></v-spacer> 

        <v-dialog v-model="dg_gallery">
            <template v-slot:activator="{ on }">
                <v-btn flat v-on="on" @click="goHome">Gallery</v-btn>
            </template>
            <v-card dark>
              <v-card-title class="headline grey lighten-2">Galleries</v-card-title>
              <v-card-text>
                <v-layout row align-center justify-center fill-height>
                  <v-flex xs12>
                    <v-card flat class="mt-2">
                        <v-card-text class="px-5">
                          <v-layout wrap row>
                            <v-flex v-for="gal in gallery" :key="gal.type">
                              <p class="gallery-title">{{ gal.title }}</p>
                                <a @click="goToGallery(gal.type)">
                                  <span :class="`gallery_sprites gallery_icon ${gal.class}`"></span>
                                </a>
                            </v-flex>
                          </v-layout>             
                      </v-card-text>  	
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="white" flat @click="dg_gallery = false" >
                  Ok
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn class="menu-btn hidden-sm-and-down" 
                    flat v-for="link in links" 
                    :key="link.text" 
                      router 
                    :to="link.href">

              <span class="mr-2">{{ link.text }}</span>
            </v-btn>  

        <v-dialog v-model="dg_contscts" width="500">
            <template v-slot:activator="{ on }">
                <v-btn flat v-on="on">Contacts</v-btn>
            </template>
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>Maria Danishvar</v-card-title>
              <v-card-text>
                <v-layout row align-center justify-center fill-height>
                  <v-flex xs12>
                    <v-card class="mt-2">
                        <v-card-text class="px-5">
                          <p class="subheading">masha_danishvar @ hotmail .co .uk</p>  
                          <p class="subheading">+44 (0) 7402 890775</p>
                      </v-card-text>  	
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="dg_contscts = false" >
                  Ok
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      <Drawer :drawer="drawer" />
    </v-layout>
  </nav>
</template>

<script>
  import Drawer from '@/components/Drawer'
  export default {
    name: 'Header',
    components: {
      Drawer
    },
  data () {
    return {
      dg_contscts: false,
      dg_gallery: false,
      drawer: false,
      links: [
        {text: 'Номе', href: '/'}, 
        {text: 'Art Lessons', href: '/lessons'},
        {text: 'Portraits', href: '/portraits'},  
        {text: 'About', href: '/about'}
      ],
      gallery: [
        {title: 'Portraits', class: 'gal-portraits', type: 'portraits'}, 
        {title: 'Dancers', class: 'gal-dancers', type: 'dancers'},
        {title: 'Musicians', class: 'gal-musicians', type: 'musicians'},  
        {title: 'Figures', class: 'gal-figures', type: 'figures'}, 
        {title: 'Interiors', class: 'gal-interiors', type: 'interiors'},
        {title: 'Still-life', class: 'gal-stilllife', type: 'life'},    
        {title: 'Landscapes', class: 'gal-lanscapes', type: 'landscapes'},                
        {title: 'Cityscapes', class: 'gal-cityscapes', type: 'cityscapes'}
      ]
    }
  },
  methods: {
      toggleDrawer() {
        this.drawer = !this.drawer
      },
      goToGallery(type){
        this.dg_gallery = false
        this.$router.push({name: 'Gallery', params: {type} })
      },
      goHome(){
        this.$router.push({name: 'Home'})
      }
    }
}
</script>

<style>
  .menu-btn {
      font-family: Tahoma!important;
      color: #969595!important;
      font-size: 14px!important;
      font-weight: normal!important;
      text-transform: capitalize!important;
    }
    .gal-menu {
      margin-top: 120px;
    }
</style>